// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__1OI3U","load1":"Spinner_load1__1RK5n"};